import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Tag } from 'primereact/tag'
import { mockSubscriptions, mockClients, mockProjects } from '../../../mocks'
import { subscriptionStatusLabel, subscriptionStatusSeverity } from '../utils/subscriptionHelpers'
import { projectStatusLabel, projectStatusSeverity } from '../../Projects/utils/projectHelpers'

const SubscriptionDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const subscription = mockSubscriptions.find((s) => s.id === id)
  if (!subscription) {
    return (
      <div>
        <Button icon='pi pi-arrow-left' text label='Voltar' onClick={() => navigate(-1)} />
        <p>Assinatura não encontrada.</p>
      </div>
    )
  }

  const client = mockClients.find((c) => c.id === subscription.clientId)
  const projects = mockProjects.filter((p) => subscription.projectIds.includes(p.id))

  const renewalDate = new Date(subscription.renewalDate)
  const today = new Date()
  const daysToRenewal = Math.ceil((renewalDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24))

  return (
    <div style={{ maxWidth: 900 }}>
      <Button
        icon='pi pi-arrow-left'
        text
        label='Voltar para Assinaturas'
        onClick={() => navigate('/dashboard/assinaturas')}
        style={{ marginBottom: '1.5rem' }}
      />

      <Card style={{ marginBottom: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
              <h2 style={{ margin: 0 }}>Plano {subscription.planName}</h2>
              <Tag
                value={subscriptionStatusLabel(subscription.status)}
                severity={subscriptionStatusSeverity(subscription.status)}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem' }}>
              <div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>Cliente</div>
                <div
                  style={{ fontWeight: 600, cursor: 'pointer', color: 'var(--primary-color)' }}
                  onClick={() => client && navigate(`/dashboard/clientes/${client.id}`)}
                >
                  {client?.name ?? '–'}
                </div>
              </div>
              <div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>Mensalidade</div>
                <div style={{ fontWeight: 700, fontSize: '1.2rem', color: 'var(--primary-color)' }}>
                  R$ {subscription.monthlyPrice.toLocaleString('pt-BR')}
                </div>
              </div>
              <div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>Início</div>
                <div style={{ fontWeight: 600 }}>{new Date(subscription.startDate).toLocaleDateString('pt-BR')}</div>
              </div>
              <div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>Renovação</div>
                <div style={{ fontWeight: 600, color: daysToRenewal < 30 ? '#f59e0b' : undefined }}>
                  {renewalDate.toLocaleDateString('pt-BR')}
                  {subscription.status === 'active' && (
                    <span style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginLeft: '0.5rem' }}>
                      ({daysToRenewal} dias)
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Card title='Aplicativos Incluídos'>
        {projects.length === 0 ? (
          <p style={{ color: 'var(--text-color-secondary)' }}>Nenhum aplicativo vinculado.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {projects.map((p) => (
              <div
                key={p.id}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', borderRadius: 8, background: 'var(--surface-ground)', cursor: 'pointer' }}
                onClick={() => navigate(`/dashboard/aplicativos/${p.id}`)}
              >
                <div>
                  <div style={{ fontWeight: 600 }}>{p.name}</div>
                  <div style={{ fontSize: '0.82rem', color: 'var(--text-color-secondary)' }}>{p.hosting}</div>
                </div>
                <Tag value={projectStatusLabel(p.status)} severity={projectStatusSeverity(p.status)} />
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  )
}

export default SubscriptionDetailPage
